export default __webpack_public_path__ + "static/media/maya-3.8bd072e0.jpg";